import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../../../../../../../../../../ui-library';
import { getShadowAccountPledgeColumns } from '../../constants';
import useFormatting from '../../../../../../../../../../locale/useFormatting';

import '../../styles/styles.css';

const DepotInformationTable = ({ saldoData }: { saldoData: any }) => {
    const { t } = useTranslation();
    const { getFormattedDate, getFormattedNumber } = useFormatting();

    const data = useMemo(() => {
        const item = {
            pledgeName: saldoData?.pledgeName,
            pledgeWef1: saldoData?.pledgeWef1,
            pledgeWef2: saldoData?.pledgeWef2,
            pledgeWef3: saldoData?.pledgeWef3,
            pledgeWef4: saldoData?.pledgeWef4,
            pledgeWefAmount: saldoData?.pledgeWefAmount,
            pledgeSetupDate: saldoData?.pledgeSetupDate,
        };

        if (Object.values(item).some(f => !!f)) {
            return [item];
        }

        return [];
    }, [saldoData]);

    const columns = useMemo(() => getShadowAccountPledgeColumns({ getFormattedDate, getFormattedNumber, t }), [t, getFormattedDate, getFormattedNumber]);

    return (
        <Table
            className="pledge-table"
            columns={columns}
            data={data}
        />
    );
};

export default DepotInformationTable;
